import { render, staticRenderFns } from "./business-client.vue?vue&type=template&id=3a527226"
import script from "./business-client.vue?vue&type=script&lang=js"
export * from "./business-client.vue?vue&type=script&lang=js"
import style0 from "./business-client.vue?vue&type=style&index=0&id=3a527226&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports